import { RelacionesEditorComponent } from './relaciones-editor/relaciones-editor.component';
import { UserSessionService } from '../../UserSession/user-session.service';

import { Component, Input, OnInit, TemplateRef, OnDestroy, ViewChild, ElementRef, ViewChildren } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CustomEntityService } from '../../apiclient/api/customEntity.service';
import { CustomEntityUtils } from '../../custom-entity-utils.service';
import { TypePropertyFieldListElementComponent } from './typepropertyfieldListElement.components';
import { LocalDataSource, ViewCell } from 'ng2-smart-table';


/**
 * Componente que renderiza la columna de acciones personalziadas de la tabla de elementos
 */
@Component({
  templateUrl: './custom.element.actions.cell.component.html',
})
export class CustomElementActionsCellComponent implements ViewCell,OnInit {

  mySubscription: any;
  sourceJoins: LocalDataSource = new LocalDataSource();
  entities:any;
  elementId:any;
  customElement: any = {};


  elementJoins = {
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="nb-plus"></i><span>Nuevo</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    edit: {
      editButtonContent: '<i class="far fa-edit"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline"></i>',

    },
    columns: {
      entity_name: {
        title: 'Entidad Relacionada',
        type: 'text',
        editable: false,
      },
      id: {
        title:'Elemento Relacionado',
        valuePrepareFunction: (cell,row) => {
          return row.name;
        },
        type: 'text',
        editor: {
          type: 'custom',
          component: TypePropertyFieldListElementComponent,
        }
      },
    },
  };



  constructor(
    private dialogService: NbDialogService,
    private userSessionService : UserSessionService,
    private customEntityService: CustomEntityService,
    private router: Router,
    private customEntityUtils: CustomEntityUtils
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }
  value: string | number;
  rowData: any;

  /**
   * @ignore
   */
  ngOnInit() {
    this.customElement.dependency = this.value;


  }

  /**
   * Abre el diálogo de dependencias
   */
  async abrirDepencencias():Promise<void>{

    this.entities = await this.customEntityUtils.getEntities();

    this.elementId = this.rowData.id

    let dialogRef: NbDialogRef<any> = await this.dialogService.open(RelacionesEditorComponent,{context:{entities: this.entities, elementId :this.elementId},dialogClass: 'model-full'});

    console.log(dialogRef.componentRef);
    console.log("Fin Dialog")

  }

  /**
   * Actualiza las relaciones
   */
  updateJoins():void{

    let listaJoins = []
    this.sourceJoins.getElements().then(async (elementos) =>{

      for (const key in elementos) {
        const element = parseInt(elementos[key].id);
        listaJoins.push(element)
      }
      await this.customEntityService.updatecustomelementjoins(this.elementId, this.customEntityUtils.getInEditionCompany(), listaJoins,this.userSessionService.accessToken).toPromise();
      this.userSessionService.invalidateCachedCustomEntities()

    })
  }


}
